export default [{
  id: '9553dfe1-8ef1-45ef-977d-019ee1f32c3d', // id 全局唯一，终身制
  name: 'cableTrayManagementVulkan',
  path: '/cable-tray-vulkan',
  meta: {
    title: '电缆桥架管理'
  },
  // layout: 'default',
  // 根菜单不需要定义 component，由主框架定义
  children: [{
    id: '4a8664ff-b991-44ad-b11b-b855c573d086',
    path: 'index',
    name: 'cableist',
    component(resolve) {
      require(['./views/index'], resolve)
    },
    meta: {
      title: '电缆桥架',
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        }
      },
    },
  },
  {
    id: '45afe72a-e3c4-44c7-8153-bb698541014e',
    path: 'create-cable',
    name: 'create-cable',
    component(resolve) {
      require(['./views/create'], resolve)
    },
    meta: {
      title: '新增电缆桥架',
      hidden: true,
      operations: {
        create: {
          id: 0,
          name: 'create',
          desc: '新增',
          access: true,
        },
        read: {
          id: 1,
          name: 'read',
          desc: '详情',
          access: true,
          group: 'read',
        },
        update: {
          id: 2,
          name: 'update',
          desc: '修改',
          access: true,
        },
        delete: {
          id: 3,
          name: 'delete',
          desc: '删除',
          access: true,
        },
      },
    },
  },


  ],
},


]
